import React, { useState } from 'react';
import { EMAIL, profiles, gitlab } from '../data/links';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [opened, setOpened] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // There is no mail-sending backend, so the form hands the message to the
  // visitor's own email app with everything pre-filled.
  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(formData.subject || `Hello from ${formData.name}`);
    const body = encodeURIComponent(
      `${formData.message}\n\n${formData.name}\n${formData.email}`
    );
    window.location.href = `mailto:${EMAIL}?subject=${subject}&body=${body}`;
    setOpened(true);
  };

  return (
    <div className="page contact-page">
      <h1 className="page-title">Say hello</h1>
      <p className="page-description">
        Questions about a project, a trail, or anything else. I read everything
        and reply when I am back at a keyboard.
      </p>

      <div className="contact-container">
        <div className="contact-info">
          <div className="info-item">
            <h3>Email</h3>
            <p><a href={`mailto:${EMAIL}`}>{EMAIL}</a></p>
          </div>

          <div className="info-item">
            <h3>Elsewhere</h3>
            <div className="social-links">
              {[...profiles, gitlab].map((p) => (
                <a key={p.label} href={p.url} target="_blank" rel="noopener noreferrer">{p.label}</a>
              ))}
            </div>
          </div>
        </div>

        <div className="contact-form-container">
          {opened && (
            <div className="form-message" role="status">
              Your email app should be open with the message ready to send. If
              nothing happened, write to <a href={`mailto:${EMAIL}`}>{EMAIL}</a> directly.
            </div>
          )}

          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                autoComplete="name"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Your email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                autoComplete="email"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="subject">Subject</label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="6"
                required
              />
            </div>

            <button type="submit" className="submit-button">Open in my email app</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
